import React, { Fragment } from "react";
import {useQueryClient} from "react-query";
import { Icon, makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { useTripLegs } from "../../../services/trips";
import { ActionButton } from "./controls";
import { PilotIcon } from "../../../icons";
import PassengerIcon from "../../../icons/PassengerIcon";
import TripToolTipStyles from "../TripToolTipStyles";
import __ from "lodash";

const CrewScreen = (props) => {
  const {tripData, eventBus} = props; 
  const classes = makeStyles(TripToolTipStyles)();

  const queryClient = useQueryClient();
  const extraKeys = [tripData.tripUuid, tripData.uuid];
  const tripLeg = useTripLegs({queryClient, extraKeys});
  const tripPrefix = process.env.REACT_APP_TRIP_PREFIX || 'MAG';
  let tripNo;
  if (`${tripData.tripNo}`.startsWith(process.env.REACT_APP_TRIP_PREFIX || 'MAG')) {
    tripNo = tripData.tripNo.substring(3);
  } else {
    tripNo = `${tripData.tripNo}`;
  }
  const leg = tripLeg?.data||{};

  return (<Fragment>
    <div style={{width: "100%", paddingBottom: 5}}>
      <div style={{display: "inline-block"}}><PilotIcon style={{position: "relative", top: 2}}/></div>
      <div style={{display: "inline-block", textAlign: "left", fontSize: 20, fontWeight: "bold", marginLeft: 3}}>Crew Details</div>
      <div style={{display: "inline-block", float:"right", textAlign: "right"}}>
        <ActionButton 
          variant="outlined" 
          startIcon={<Icon>edit</Icon>}
          onClick={()=>{
            eventBus.trigger("RouteView.TimeWindow.TripAction.editCrew",{tripData: {...tripLeg.data, tripPrefix, tripNo}, extraKeys});
          }}
        >
          Edit
        </ActionButton>
      </div>
    </div>
    <div style={{width: "100%"}}>
      <Table className={classes.crewTable}>
        <TableHead>
          <TableRow className={classes.crewTableHeader}>
            <TableCell className={classes.crewTableHeaderCell} width="15%">Func.</TableCell>
            <TableCell className={classes.crewTableHeaderCell} width="15%">Code</TableCell>
            <TableCell className={classes.crewTableHeaderCell} width="60%">Name</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {__.orderBy(leg.crew||[], ['deadhead','sequence','function'], ['asc','asc','asc']).map(crew => (
            <TableRow className={crew.deadhead?classes.crewTableDeadHeadLine:classes.crewTableLine}>
              <TableCell className={classes.crewTableCell}>{crew.function}</TableCell>
              <TableCell className={classes.crewTableCell}>{crew.code}</TableCell>
              <TableCell className={classes.crewTableCell}>{crew.name}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>

    <div style={{height: 15}}></div>

    <div style={{width: "100%", paddingBottom: 5}}>
      <div style={{display: "inline-block"}}><PassengerIcon style={{position: "relative", top: 2}}/></div>
      <div style={{display: "inline-block", textAlign: "left", fontSize: 20, fontWeight: "bold", marginLeft: 3}}>Pax Details</div>
      <div style={{display: "inline-block", float:"right", textAlign: "right"}}>
        <ActionButton 
          variant="outlined" 
          startIcon={<Icon>edit</Icon>}
          onClick={()=>{
            eventBus.trigger("RouteView.TimeWindow.TripAction.editPax",{tripData: {...tripLeg.data, tripPrefix, tripNo}, extraKeys});
          }}
        >
          Edit
        </ActionButton>
      </div>
    </div>
    <div style={{width: "100%"}}>
      <Table className={classes.paxTable}>
        <TableHead>
          <TableRow className={classes.paxTableHeader}>
            <TableCell className={classes.paxTableHeaderCell} width="60%">Name</TableCell>
            <TableCell className={classes.paxTableHeaderCell} width="40%">Passport</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(leg.passengers||[]).map(pax => (
            <TableRow className={classes.paxTableLine}>
              <TableCell className={classes.paxTableCell}>{pax.knownAs}</TableCell>
              <TableCell className={classes.paxTableCell}>{pax.passportNumber}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>

  </Fragment>); 
}

export default CrewScreen;